import WhatsappButton from './WhatsappButton';

export default WhatsappButton;
